// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Q7Naq","icon":"styles_icon__mdNWC"};